export default __webpack_public_path__ + "static/media/placeholder_dummy2016-modelportfolio01-de-mobile.413423a5.png";